<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">お気に入り</li>
            </ol>
        </nav>
        <div class="container">
            <div class="sticky">
                <page :last_page="favorites.last_page" v-model="page" @goto="goto"></page>
            </div>
            <div v-if="favorites.total">
                <book-card
                    v-for="f in favorites.data"
                    :book="f"
                    :favorite="true"
                    @updated="load()"
                    :key="f.id"></book-card>
            </div>
            <div v-else class="nothing">
                お気に入りの本はまだありません。
            </div>
        </div>
    </div>
</template>

<script>
import page from "components/Page";
import novel from "./parts/Novel";
import bookCard from "pages/author/bookCard";
export default {
    components: {
        page,
        novel,
        bookCard,
    },
    data() {
        return {
            favorites: [],
            page: 1,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load();});
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            axios.get("/mypage/favorites/get", {'params': {'page': this.page}}).then(res => {
                this.favorites = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        getLink(book) {
            let subdomain = "www";
            if (this.book?.author?.subdomain) {
                subdomain = this.book.author.subdomain;
            }
            return `//${subdomain}${this.$store.state.base_domain}/author/book/${book.id}`;
        }
    },
    mounted() {
        this.load();
        setTimeout(() => {
            this.useHead({
                title: "お気に入り | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    }
}
</script>